<template>
    <div class="address">
        <div class="address-inner">

          <admin-sidebar></admin-sidebar>

          <div class="table">
            <div class="table-header address-admin">
              <div class="table-title">
              </div>
              <div class="table-header-actions">
                <div v-if="this.$hasRole(['admin'])" class="add-address mobile-hide">
                  <a @click.prevent="addAddress" ref="add-address" class="button">
                    add address
                  </a>
                </div>
              </div>
            </div>
            <div class="address-list" v-loading="loading">
                <div class="address-list-inner" v-if="addresses">
                    <div class="address-list-item" v-for="(item, index) in addresses" :key="index">
                        <span class="address-list-item-close" @click="deleteAddresses(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path id="ic_close_24px" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)" fill="#666"/></svg>
                        </span>

                        <template v-if="item.addressLine1">
                            {{item.addressLine1}},
                        </template>
                        <template v-if="item.addressLine2">
                            {{item.addressLine2}},
                        </template>
                        <template v-if="item.city">
                            {{item.city}},
                        </template>
                        <template v-if="item.state">
                            {{item.state}},
                        </template>
                        <template v-if="item.zipCode">
                            {{item.zipCode}},
                        </template>
                        <template v-if="item.country">
                            {{item.country}}
                        </template>
                    </div>
                </div>
            </div>
          </div>

          <div class="table-mobile">
            <div class="table-mobile-header">
              <div>{{addresses.length + ' ' + (addresses.length === 1 ? 'address' : 'addresses')}}</div>
              <div v-if="this.$hasRole(['admin'])" class="add-address">
                <a @click.prevent="addAddress" class="button">add address</a>
              </div>
            </div>
            <div class="table-mobile-items">
              <div class="table-mobile-items-item" v-for="item in addresses" :key="item.id">
                <div class="table-mobile-items-item-left">
                  <div class="table-mobile-items-item-left-lower">
                    <template v-if="item.addressLine1">
                      {{item.addressLine1}},<br/>
                    </template>
                    <template v-if="item.addressLine2">
                      {{item.addressLine2}},<br/>
                    </template>
                    <template v-if="item.city">
                      {{item.city}},
                      <template v-if="item.state">
                        {{item.state}}<br/>
                      </template>
                    </template>
                    <template v-if="item.zipCode">
                      {{item.zipCode}}<br/>
                    </template>
                    <template v-if="item.country">
                      {{item.country}}
                    </template>
                  </div>
                </div>
                <div class="table-mobile-items-item-right">
                  <a @click.prevent="deleteAddresses(item)" class="button">remove</a>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import AdminSidebar from '@/views/Private/Components/AdminSidebar'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'AddressManage',
  components: { AdminSidebar },
  metaInfo () {
    return {
      title: 'Address'
    }
  },
  data () {
    return {
      loading: true,
      form: {
        addressLine1: null,
        addressLine2: null,
        city: null,
        country: null,
        state: null,
        zipCode: null
      },
      addresses: []
    }
  },
  created () {
    EventBus.$on('reload-addresses', () => this.loadAddresses())
    this.loadAddresses()
  },
  beforeDestroy () {
    EventBus.$off('reload-addresses', true)
  },
  methods: {
    addAddress () {
      EventBus.$emit('open-modal', {
        type: 'address-add',
        data: {},
        header: true
      })
    },
    deleteAddresses (address) {
      EventBus.$emit('open-modal', {
        type: 'address-remove',
        header: false,
        data: {
          address: address
        }
      })
    },
    loadAddresses () {
      HTTP({
        method: 'GET',
        url: '/api/v1/orders/address',
        crossdomain: true
      }).then(response => {
        this.addresses = response.data.data
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$notify({
          // title: 'Error',
          dangerouslyUseHTMLString: true,
          message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
      })
    }
  }
}
</script>
